import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { DataGeneratableDocumentTemplateWithAllRelationsTct } from '@dealstack/shared/lib/generated';
import { createDateColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/DateColumn';
import { ProjectsBadges } from '@dealstack/frontend/admin/pages/common-ui/ProjectsBadges';
import { isNotEmpty } from '@dealstack/shared/lib/isNotEmpty.ts';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { Button } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { generatableDocumentEditPath } from '@dealstack/frontend/admin/pages/Manage/ManageGeneratableDocuments/ManageGeneratableDocuments.utils.ts';

const EditButton = ({ templateId }: { templateId: string }) => {
	const navigate = useNavigate();

	return (
		<Button
			variant="ghost"
			onClick={() => {
				navigate(generatableDocumentEditPath(templateId));
			}}
		>
			Edit
		</Button>
	);
};

const createGeneratableDocumentsActionColumn =
	(): ExtendedColumnDef<DataGeneratableDocumentTemplateWithAllRelationsTct> => {
		return {
			cell: ({ row }) => {
				return <EditButton templateId={row.original.id} />;
			},
			header: '',
			id: 'actions',
			enableGlobalFilter: false,
			enableColumnFilter: false,
			filter: () => <div />,
			size: 80,
			meta: {
				isGrow: true,
			},
		};
	};

export const GENERATABLE_DOCUMENTS_TABLE_COLUMNS: ExtendedColumnDef<DataGeneratableDocumentTemplateWithAllRelationsTct>[] =
	[
		createTextColumn({ headerText: 'Template name', accessorKey: 'name' }),
		createTextColumn({
			id: 'assignedProjects',
			headerText: 'Assigned projects',
			accessorFn: ({ generatableDocumentWorkflowTemplateProjects }) =>
				generatableDocumentWorkflowTemplateProjects.map(
					(projectRelation) => projectRelation.deal.name
				),
			cell: ({ cell }) =>
				isNotEmpty(cell.getValue<string[]>()) ? (
					<ProjectsBadges projectsNames={cell.getValue<string[]>()} />
				) : (
					LONG_DASH
				),
			filterFn: 'includesString',
			enableSorting: false,
		}),
		createDateColumn({
			id: 'updatedAt',
			headerText: 'Updated at',
			accessorFn: ({ updatedAt }) => !!updatedAt && new Date(updatedAt),
			sortingFn: 'datetime',
		}),
		createGeneratableDocumentsActionColumn(),
	];
